import { useState, useEffect } from 'react'
import { isBrowser } from '../utils/is-browser'

// ----------------------------------------------------------------------

const useSessionStorage = (key, initialValue) => {
  if (!isBrowser) {
    return [initialValue, () => {}]
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [value, setValue] = useState(() => {
    try {
      const sessionStorageValue = sessionStorage.getItem(key)

      if (typeof sessionStorageValue !== 'string') {
        sessionStorage.setItem(key, JSON.stringify(initialValue))
        return initialValue
      } else {
        return JSON.parse(sessionStorageValue || 'null')
      }
    } catch {
      return initialValue
    }
  })

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}

export default useSessionStorage
